<template>
  <div class="police">
    <SelectMonth @fMethod="getDate" :startData="startData" :endData="endData"></SelectMonth>
      <div id="equmentBlock" ref="chart"></div>
  </div>
</template>
<script>
import SelectMonth from './../../a-module/block-selectMonth.vue'
import {url,operate} from '@/utils/config'
import {postFun,getFun} from '@/utils/httpFun'
export default {
  components:{
      SelectMonth:SelectMonth,
  },
  props:{
    width:{
      type:Number,
      default:100
    }  
  },
  data: ()=>({
    startData:null,
    endData:null,
     parms:{
        endTime:"",
        startTime:"",
        timeType:1,    //1近七天 2近一个月 3近一年
     },
     interval:0,
     fontSize:10,
     align:'',
     rotateVal:'0',
     myChart:{}
  }),
  computed: {
      refreshStr() {
         return this.$store.state.windowwidth || this.$store.state.windowwidth;
      }
   },
    watch: {
      refreshStr(val) {
         if (val) {
            this.myChart.resize()
         }
      }
   },
  mounted() {
     this.getInfo()
  },
  methods:{
    getDate(ev){ 
        

       this.parms.timeType = ev.type
       let isMark = ev.type==4 &&!!ev.endTime&&!!ev.startTime 
       if(isMark){
         this.parms.endTime =  ev.endTime
         this.parms.startTime =  ev.startTime
         this.getInfo()
       }else{
          if(ev.type!=4){
            console.log('==========',ev)
            this.parms.endTime =  ev.endTime
            this.parms.startTime =  ev.startTime
            this.getInfo()
          }
       }
    },
    //获取的数据
    getInfo(){
            let xVal = []
            let xListValA = []
            let xListValB = [] 
            console.log('=========parms==',this.parms)
            postFun(operate.EQBAOJINGLIST,this.parms,res=>{
                let list = res.data.list
                this.startData = list[0].time
                this.endData = list[list.length-1].time
                list.forEach(element => {
                    xVal.push(element.time)
                    xListValA.push(element.redCounts)
                    xListValB.push(element.greenCounts)
                });
                this.xVal = xVal

                if(this.xVal.length >= 32){
                    this.interval = 4;
                    this.fontSize = 8;
                    this.align = '';
                }else if(this.xVal.length >= 1 || this.xVal.length <= 8){

                    this.xVal = this.xVal.map((item,index)=>{
                        let xValArr = item.split('-');
                        return xValArr[1]+'-'+xValArr[2]
                    })

                    this.interval = 0;
                    this.align = 'right';
                    this.fontSize = 10
                    
                }else if(this.xVal.length > 8 && this.xVal.length <=31){

                    this.xVal = this.xVal.map((item,index)=>{
                        let xValArr = item.split('-');
                        return xValArr[1]+'-'+xValArr[2]
                    })

                    this.interval = 0;
                    this.align = 'right';
                    this.fontSize = 10

                }else {
                    this.interval = 0;
                    this.fontSize = 10;
                    this.align = '';
                }

                console.log('xVal',this.xVal);
                // this.xVal.push({})
                this.xListValA = xListValA
                this.xListValB = xListValB
                this.init()
            })
      },
      
      
      init() {

            let myChart = this.$_echarts.init(document.getElementById('equmentBlock'))
            this.myChart = myChart
            var option = {
                title: {},
                tooltip: {
                    show:true,
                    trigger: 'axis',
                    position: function (pt) {
                        return [pt[0], '10%'];
                    }
                },
                legend: {
                    x: 'center',
                    // y: 'bottom',
                    bottom:'46',
                    data: ['报警设备数量', "正常设备数量"],
                    itemGap: 30,
                    icon:"roundRect",
                    itemWidth: 16,
                    itemHeight: 10,
                    itemStyle: {
                        borderCap: 'round'
                    }
                },
                grid: { //方法 2
                    x: 0,
                    y: 10,
                    x2: 8,
                    y2: 73,
                    containLabel: true
                },
                dataZoom: [
                    {
                        type: 'inside'
                    },
                    {
                        type: 'slider'
                    }
                ],
                xAxis: {
                    data: this.xVal,
                    boundaryGap: false,
                    axisLine:{
                        show:false,
                    },
                    axisTick: {
                        show:false,
                        alignWithLabel: true,
                        // length:13
                    },
                    
                    axisLabel:{
                        interval:this.interval,
                        align:this.align,
                        textStyle:{
                            fontSize:this.fontSize,
                        }
                    },
                    splitArea : {show : false}
                },
                yAxis: {
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '报警设备数量',
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        data: this.xListValA,
                        barWidth: 1,
                        itemStyle: {
                            color: "#FE564E",
                        },
                        lineStyle: {
                            color: '#FE564E',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(254,86,78,0.6)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(254,86,78,0.1)'
                            },
                         ])
                        },
                    },
                    {
                        name: '正常设备数量',
                        type: 'line',
                        symbol: "none",
                        smooth:true,
                        sampling: 'average',
                        barWidth: 1,
                        data: this.xListValB,
                        itemStyle: {
                            color: "#0095FF",
                        },
                        lineStyle: {
                            color: '#0095FF',
                            width: 1
                        },
                        areaStyle: {
                            color: new this.$_echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(0,149,255,0.5)'
                            }, {
                                offset: 1,
                                color: 'rgb(235,246,254,0.1)'
                            }])
                        },
                    },
                    
                ]
            }
            this.myChart.setOption(option);
        },
  },
}
</script>
<style lang="scss" scoped>
    #equmentBlock{
       width: 100%;
       height:268px;
       margin-top: 20px;
    }
</style>
